import { DotsHorizontal } from '@branch-messenger/willow-ui/icons'
import { useMediaQuery } from '@uidotdev/usehooks'
import { FC } from 'react'

import { mediaQueries } from '@/styles/media'

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../dropdown-menu'
import { SidebarMenuProps } from './types'

export const SidebarMenuMobile: FC<SidebarMenuProps> = ({ menuItems }) => {
  const isMobile = useMediaQuery(mediaQueries.largeTabletAndDown)
  if (!isMobile) return null
  return (
    <DropdownMenu
      trigger={<DropdownMenuTrigger Icon={DotsHorizontal} />}
      showArrow={false}
    >
      {menuItems.map(menuItem => (
        <DropdownMenuItem
          key={menuItem.title}
          showArrowRight={false}
          titleSize="xs"
          {...menuItem}
        />
      ))}
    </DropdownMenu>
  )
}
